const chatQuestionAddValid = (input) => {
  const validChars = /^((?!.*[Ð×Þß÷þø])[.[\\\]{}(),:+;0-9-'"a-zA-ZÀ-ÿŒœ?!@$`_^ç=&£€%/|#²°*µ<> ]{2,255})$/.test(input);

  const empty = /^$/.test(input);

  return (validChars || empty);
};

export default chatQuestionAddValid;
